<template>
  <el-dialog id="user-crud"
             :title="((this.user) ? 'Edit' : 'Create') + ' User'"
             @close="close"
             v-loading="loading"
             :element-loading-text="(this.deleting) ? 'Deleting User...' : 'Saving User...'"
             :visible.sync="isVisible"
             :width="(isDialogFullscreen) ? '' : '480px'"
             :fullscreen="isDialogFullscreen">

    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="user-form">
      <el-form-item  label="Avatar (150x150)" prop="icon">
        <el-upload
          class="icon-uploader circular"
          :class="{uploaded: imagePreviewUrl}"
          v-loading="iconLoading"
          :action="UsersIconURL"
          :headers="uploadFormHeaders"
          drag
          :show-file-list="false"
          :on-success="handleIconSuccess"
          :before-upload="beforeIconUpload">
          <img v-if="imagePreviewUrl" :src="imagePreviewUrl" class="icon">
          <i v-else class="el-icon-plus icon-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="Position" prop="position">
        <el-input v-model="form.position" auto-complete="off" />
      </el-form-item>
      <el-form-item label="First Name" prop="first_name">
        <el-input v-model="form.first_name" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Last Name" prop="last_name">
        <el-input v-model="form.last_name" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Email" prop="email">
        <el-input v-model="form.email" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input v-model="form.password" auto-complete="off" type="password" />
      </el-form-item>
      <el-form-item label="Role" prop="role" v-if="isAdmin">
        <el-radio-group v-model="form.role">
          <el-radio-button label="Staff" />
          <el-radio-button label="Admin" />
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Active" prop="status" v-if="isAdmin">
        <el-switch v-model="form.status" />
      </el-form-item>
      <el-form-item label="Reports" prop="access_reports" v-if="isAdmin">
        <el-switch v-model="form.access_reports" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger"
                 class="pull-left"
                 @click="deleteUser"
                 v-if="user != null && isAdmin">Delete</el-button>
      <el-button @click="isVisible = false">Cancel</el-button>
      <el-button type="primary" @click="submit">Confirm</el-button>
    </span>

    <el-dialog
      width="30%"
      title="Are you sure?"
      :visible.sync="isConfirmDeleteVisible"
      append-to-body>
      <p>The selected user will be <b>permanently deleted!</b></p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isConfirmDeleteVisible = false">Cancel</el-button>
          <el-button type="danger" @click="onConfirmDeleteUser">Delete User</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import {UsersIconURL} from '../../util/api'
  export default {
    name: 'user-crud',
    props: {
      user: {
        default: null
      }
    },
    data () {
      let validatePass = (rule, value, callback) => {
        if (this.user === null || value !== '') {
          // New user. Password is always required
          // Existing user. Only validate if they try to change the password
          if (value === '' || value < 6) {
            callback('Password must be at least 6 characters')
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        isVisible: true,
        isConfirmDeleteVisible: false,
        loading: false,
        windowWidth: 0,

        UsersIconURL: UsersIconURL,
        uploadFormHeaders: {
          'Authorization': 'Bearer ' + this.$store.state.accessToken
        },
        iconLoading: false,
        imagePreviewUrl: false,
        form: {
          first_name: '',
          last_name: '',
          position: '',
          email: '',
          password: '',
          role: 'Staff',
          status: true,
          access_reports: false,
          icon: null
        },

        rules: {
          first_name: [
            { required: true, message: 'First Name is required', trigger: 'blur' }
          ],
          last_name: [
            { required: true, message: 'Last Name is required', trigger: 'blur' }
          ],
          email: [
            { required: true, message: 'Email Address is required', trigger: 'blur' },
            { type: 'email', message: 'Email Address is not in valid format', trigger: 'blur' }
          ],
          password: [
            { validator: validatePass, trigger: 'blur' }
          ],
          position: [
            { required: true, message: 'Position is required', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      deleteUser () {
        // Show the delete confirm dialog - dont want any accidents now
        this.isConfirmDeleteVisible = true
      },
      onConfirmDeleteUser () {
        this.isConfirmDeleteVisible = false
        this.$store.dispatch('deleteUser', this.user)
      },
      submit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // @Note: See watcher 'saving' for the success/error handling of this action
            var object = {
              id: (this.user) ? this.user.id : null,
              first_name: this.form.first_name,
              last_name: this.form.last_name,
              email: this.form.email,
              position: this.form.position,
              icon: this.form.icon
            }

            if (this.isAdmin) {
              // Only admins can assign roles.
              // Note the backend will default to 'Staff' if no role is supplied on creation
              object.role = this.form.role
              object.status = (this.form.status === true) ? 1 : 0
              object.access_reports = (this.form.access_reports === true) ? 1 : 0
            }
            // Only update the password if it is either a new user, or an existing user has
            // explicitly entered text into the password field
            if (this.form.password !== '') {
              object.password = this.form.password
            }
            if (this.user) {
              // A user was passed, update it
              this.$store.dispatch('updateUser', object)
            } else {
              // A user was not passed, create a new one
              this.$store.dispatch('createUser', object)
            }
          } else {
            return false
          }
        })
      },
      setUserDetails () {
        if (this.user) {
          this.form.first_name = this.user.first_name
          this.form.last_name = this.user.last_name
          this.form.email = this.user.email
          this.form.position = this.user.position
          this.form.role = this.user.role
          this.form.status = (this.user.status === 1)
          this.form.access_reports = (this.user.access_reports === 1)
          this.form.icon = this.user.icon

          if (this.user.icon) {
            this.imagePreviewUrl = this.user.icon_url
          }
        }
      },
      getWindowWidth () {
        this.windowWidth = document.documentElement.clientWidth
      },

      handleIconSuccess (res, file) {
        this.form.icon = file.response.filename
        this.imagePreviewUrl = file.response.preview
        this.iconLoading = false
      },
      beforeIconUpload (file) {
        const isPNG = (file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPNG) {
          this.$message.error('Icon must be PNG format!')
        }
        if (!isLt2M) {
          this.$message.error('Icon size can not exceed 2MB!')
        }
        if (isPNG && isLt2M) {
          this.iconLoading = true
          return true
        }

        return false
      }
    },
    computed: {
      isDialogFullscreen () {
        return this.windowWidth < 520
      },
      saving () {
        return this.$store.state.users.createInProgress || this.$store.state.users.updateInProgress
      },
      deleting () {
        return this.$store.state.users.deleteInProgress
      },
      affectedUser () {
        return this.$store.state.users.createdObject || this.$store.state.users.updatedObject
      },
      // Vuex Mappings
      isAdmin () {
        return this.$store.getters.isAdmin
      }
    },
    created () {
      this.setUserDetails()
    },
    mounted () {
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth)
        this.getWindowWidth()
      })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.getWindowWidth)
    },
    watch: {
      'saving' () {
        // If the Project store is either POSTing or PUTing, show the loader if the action is in progress
        // otherwise handle the expected result of a save
        if (this.saving) {
          this.loading = true
        } else {
          this.loading = false
          if (!this.affectedUser) {
            // There was an error creating/updaing the project.
            // @TODO: Implement error handling
            console.error('Create/Update Failed. @TODO: Add error handling')
          } else {
            this.$message({
              message: (this.user) ? 'User updated!' : 'User created!',
              type: 'success'
            })
            this.isVisible = false
            this.$emit('close', this.affectedUser)
          }
        }
      },
      'deleting' () {
        // If the Project store is either POSTing or PUTing, show the loader if the action is in progress
        // otherwise handle the expected result of a save
        if (this.deleting) {
          this.loading = true
        } else {
          this.loading = false
          if (!this.affectedUser) {
            // There was an error creating/updaing the project.
            // @TODO: Implement error handling
            console.error('Create/Update Failed. @TODO: Add error handling')
          } else {
            this.$message({
              message: 'User deleted!',
              type: 'success'
            })
            this.isVisible = false
            this.$emit('close', this.affectedUser)
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .delete-btn {
    justify-self: flex-start;
    align-self: flex-start;
  }
</style>
